module.exports = __webpack_public_path__ + "d432890859a074f6ae757694cbea5de7.svg";